import angular from 'angular'

import template from '../../../templates/util/wr-enable-training-button.html'
import { $q } from '../../ng-compat/imports'

/**
 * Provides a common button for enabling training mode on the register.
 *
 * @module webregister.directives.wrEnableTrainingButton
 */
angular
  .module('webregister.directives')
  .directive('wrEnableTrainingButton', function () {
    return {
      scope: {
        buttonClass: '@',
        onEnable: '=?',
        buttonText: '@',
      },
      restrict: 'E',
      template,
      bindToController: true,
      controllerAs: 'enableTrainingButtonCtrl',
      /**
       * =======================================
       * ENABLE TRAINING MODE BUTTON CONTROLLER
       * =======================================
       */
      controller(
        this: $TSFixMe,
        $scope,
        posStateManager,
        trainingModeModals,
        trainingModeManager,
        saleSyncManager
      ) {
        /**
         * Updates the disabled state of the button & the disabled text
         *
         * @method updateButtonState
         */
        this.updateButtonState = function () {
          // These two properties determine the disabled state of the button
          this.hasActiveSale = Boolean(posStateManager.getActiveSaleLocalId())
          this.trainingModeEnabled = posStateManager.getTrainingModeEnabled()
          this.failedToSyncSales = saleSyncManager.failedToSyncSalesCount
          this.disabledHelpText = null

          if (this.trainingModeEnabled) {
            this.disabledHelpText = 'Training Mode is already enabled'
          } else if (this.hasActiveSale) {
            this.disabledHelpText =
              'Sorry, you must complete the current open sale before entering Training Mode'
          } else if (this.failedToSyncSales) {
            this.disabledHelpText =
              'Sorry, you must resolve your errored sales before entering Training Mode'
          }
        }

        /**
         * Enable training mode and navigate to the current sale state
         *
         * @method enableTrainingMode
         */
        this.enableTrainingMode = function () {
          const enableTrainingModeResolver = this.onEnable
            ? this.onEnable()
            : $q.resolve()

          enableTrainingModeResolver.then(() => {
            if (trainingModeManager.initiateTrainingMode()) {
              trainingModeModals
                .confirmTrainingMode()
                .then(() => trainingModeManager.initiateTrainingTour())
            }
          })
        }

        this.updateButtonState()

        posStateManager.on(
          'activeSaleLocalIdChange',
          this.updateButtonState,
          this
        )
        posStateManager.on(
          'trainingModeEnabledChange',
          this.updateButtonState,
          this
        )
        saleSyncManager.on('unsyncedSalesChange', this.updateButtonState, this)

        $scope.$on('$destroy', () => {
          posStateManager.off('activeSaleLocalIdChange', this.updateButtonState)
          posStateManager.off(
            'trainingModeEnabledChange',
            this.updateButtonState
          )
          saleSyncManager.off('unsyncedSalesChange', this.updateButtonState)
        })
      },
    }
  })
